import type { AvailableFontVariant } from 'views/Template/shared/utils'

export const headingCharacterLimitBreakpoints = new Map<number, AvailableFontVariant>([
  [60, `h2`],
  [0, `h2`],
])

export const descriptionCharacterLimitBreakpoints = new Map<number, AvailableFontVariant>([
  [500, `pSmall`],
  [370, `pMedium`],
  [0, `pLarge`],
])

export const paragraphCharacterLimitBreakpoints = new Map<number, AvailableFontVariant>([
  [370, `pMedium`],
  [0, `pLarge`],
])
